module.exports = __webpack_public_path__ + "img/哈士奇钥匙扣-2.0bf06480.jpg";